import { Component } from '@angular/core';

@Component({
	selector: 'app-root',
	template: `
<div class="container">
	<div class="d-flex mt-3 flex-fill">
		<img src="/assets/images/Integra Logo.png" style="height: 98px; margin: auto;" />
	</div>
	<router-outlet></router-outlet>
</div>`,
	styles: []
})
export class AppComponent {
}
